import React, { Component } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Header from '../../components/Header';
import Table from '../../components/Table';
import Guide from '../../components/Guide';
import locationActions from '../../actions/location';
import locationTable from '../../tables/locations'
import formHelpers from '../../helpers/FormHelpers';
import modalActions from '../../actions/modal';
import modalInfo from '../../helpers/locations/LocationInfo';
import locationFields from '../../forms/location/create';
import locationHelpers from '../../helpers/locations/buildValues';
import populateForm from '../../helpers/PopulateForm';
import MessageBar from '../../components/MessageBar';
import Modal from '../../components/Modal';
import Button from '../../components/Button';
import { extractPhasesOrFail } from '../../helpers/ValueBuilder';


class Locations extends Component {
  constructor() {
    super();
    this.handleEditClick = this.handleEditClick.bind(this);
    this.handleSelectFieldChange = this.handleSelectFieldChange.bind(this);
    this.handleNewClick = this.handleNewClick.bind(this);
    this.handleMessageClick = this.handleMessageClick.bind(this);
    this.handleModalToggle = this.handleModalToggle.bind(this);
    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleSelectClick = this.handleSelectClick.bind(this);
    this.handleFieldBlur = this.handleFieldBlur.bind(this);
    this.handleFieldFocus = this.handleFieldFocus.bind(this);
    this.performCreateOrUpdate = this.performCreateOrUpdate.bind(this);
    this.handleActiveClick = this.handleActiveClick.bind(this);
    this.resetLocation = this.resetLocation.bind(this);
  }

  componentWillMount() {
    const { dispatch, vendor } = this.props;
    if (vendor.selected && vendor.selected.apikey) {
      dispatch(locationActions.list(vendor.selected.apikey));
    }
  }

  handleSelectFieldChange(option, name) {
    formHelpers.handleSelectFieldChange(option, name, 'fields', this);
  }

  handleFieldBlur(name) {
    formHelpers.handleFieldBlur(name, 'fields', this);
  }

  handleFieldChange(value, name) {
    formHelpers.handleFieldChange(value, name, 'fields', this);
  }

  handleFieldFocus(name) {
    formHelpers.handleFieldFocus(name, 'fields', this);
  }

  handleSelectClick(name) {
    formHelpers.handleSelectClick(name, 'fields', this);
  }

  resetLocation() {
    this.setState({
      updateField: false,
      fields: locationFields
    })
  }

  performCreateOrUpdate() {
    const { fields, updateField } = this.state;
    const { dispatch, vendor } = this.props;
    let data = extractPhasesOrFail({ fields });

    dispatch(locationActions.clearLocationError());

    if (data && updateField) {
      dispatch(locationActions.update(data, vendor.selected.apikey, updateField.apikey));
    } else if (data) {
      dispatch(locationActions.create(data, vendor.selected.apikey));
    } else {
      this.setState({
        fields: formHelpers.blurphase(fields)
      })
    }
  }

  handleEditClick(loc) {
    this.resetLocation();
    this.props.dispatch(modalActions.modalToggle(true));

    let fields = _.cloneDeep(locationFields);
    if (!loc.longitude || !loc.latitude) {
      const removeFields = ['latitude', 'longitude'];
      fields = _.omit(fields, removeFields);
    }

    this.setState({
      updateField: loc,
      fields: locationHelpers.prepEdit(populateForm(loc, fields))
    })
  }

  handleNewClick() {
    this.resetLocation();
    const removeFields = ['latitude', 'longitude'];
    const fields = _.omit(locationFields, removeFields);

    this.setState({
      fields: JSON.parse(JSON.stringify(fields))
    });
    this.handleModalToggle();
  }

	handleModalToggle() {
    const { dispatch, modal } = this.props;
    dispatch(locationActions.clearLocationError());
    dispatch(modalActions.modalToggle(!modal.showModal));
	}

  handleActiveClick(loc) {
    const { dispatch, vendor } = this.props;
    let locationData = { is_active: !loc.is_active }
    dispatch(locationActions.update(locationData,
      vendor.selected.apikey, loc.apikey))
  }

  handleMessageClick() {
    this.props.dispatch(locationActions.clearLocationError());
  }

  render() {
    const { user } = this.props;

    const userIsSuper = _.get(user, 'data.role') === 'super';

    return (
      <div>
				<Header
					handlePrimaryClick={this.handleNewClick}
          handleLogout={this.props.handleLogoutClick}
          primaryText={userIsSuper ? "NEW LOCATION" : null}
          title="LOCATIONS" />
				<Table
          handleEditClick={this.handleEditClick}
					rows={this.props.location.data}
          handleActiveClick={this.handleActiveClick}
					columns={locationTable} />
					{
						this.props.modal.showModal &&
						<Modal
							handleCloseClick={this.handleModalToggle}
							title="Location">
              <MessageBar
                onClick={this.handleMessageClick}
                messageType="error"
                message={this.props.location.error}/>
							<div className="signup__guide">
								<Guide
									header={modalInfo[0].subTitle}
									message={modalInfo[0].content} />
							</div>
							<div className="signup__form">
								<div>
									{ formHelpers.buildFields(this.state.fields, this) }
								</div>
								<Button
									allowHover={true}
									text="Finish"
									onClick={this.performCreateOrUpdate}/>
							</div>
						</Modal>
          }
      </div>
    );
  }
}

export default withRouter(connect(
  (state) => {
    return {
      user: state.admin,
      modal: state.modal,
      vendor: state.vendor,
      location: state.location
    }
  }
)(Locations));



/** WEBPACK FOOTER **
 ** ./src/containers/Locations/index.js
 **/